"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var ProductSupplier_1 = require("./ProductSupplier");
/**
 * This entity represents mapping between product and secondary supplier without time validity.
 * @author PKr
 * @author VRu
 */


var ProductSecondarySupplier =
/*#__PURE__*/
function (_ProductSupplier_1$Pr) {
  _inherits(ProductSecondarySupplier, _ProductSupplier_1$Pr);

  /**
   * @param id internal document id
   * @param productId {@link Product.id}
   * @param supplierId {@link Supplier.id}
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function ProductSecondarySupplier(id, supplierId, productId, processed) {
    var _this;

    _classCallCheck(this, ProductSecondarySupplier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSecondarySupplier).call(this, productId, supplierId));
    _this.id = id;
    _this.supplierId = supplierId;
    _this.productId = productId;
    _this.processed = processed;
    return _this;
  }

  return ProductSecondarySupplier;
}(ProductSupplier_1.ProductSupplier);

exports.ProductSecondarySupplier = ProductSecondarySupplier;

ProductSecondarySupplier.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder();
  return {
    id: builder.id('id'),
    supplierId: builder.str('supplierId'),
    productId: builder.str('productId'),
    processed: builder.bool('processed')
  };
}();